import { ComponentProps, useId } from 'react'
import { cn } from '@/lib/utils'

export const Checkbox = ({
  name,
  className,
  label = '',
  description = '',
  onChange,
  ...props
}: {
  label?: string
  description?: string
  onChange: (checked: boolean) => void
} & Omit<ComponentProps<'input'>, 'onChange'>) => {
  const id = useId()

  return (
    <div className={cn('flex select-none items-center', { 'items-start': !!description }, className)}>
      <input
        id={id}
        type="checkbox"
        name={name}
        className="mr-2 inline-flex min-h-5 min-w-5 cursor-pointer border border-black bg-white accent-black disabled:cursor-not-allowed"
        onChange={({ target }) => onChange(target.checked)}
        {...props}
      />
      {label && (
        <label
          htmlFor={id}
          className={cn('flex cursor-pointer flex-col gap-1 leading-[1]', { 'mt-[.15em]': !!description })}
        >
          <span>{label}</span>
          {description && <span className="text-sm">{description}</span>}
        </label>
      )}
    </div>
  )
}
